import {
  ApplicationConfig,
  makeEnvironmentProviders,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  AuthenticationService,
  initializeKeyStates,
  KeycloakAuthenticationService,
  provideConfigFromUri,
  providePrimeNg,
} from '@ps-gui/shared-core';
import { MessageService } from 'primeng/api';
import { ClaimsTerminalConfig } from '@ps-gui/claims-terminal-shared';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';

const provideServices = () => {
  return makeEnvironmentProviders([
    {
      provide: AuthenticationService,
      useClass: KeycloakAuthenticationService,
    },
    {
      provide: MessageService,
      useClass: MessageService,
    },
  ]);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    environment.provideKeycloak(),
    provideConfigFromUri<ClaimsTerminalConfig>('./assets/config/config.json'),
    provideHttpClient(withFetch(), withInterceptors([includeBearerTokenInterceptor])),
    provideAppInitializer(() => initializeKeyStates()),
    provideServices(),
    {
      provide: DialogService,
      useClass: DialogService,
    },
    providePrimeNg(),
  ],
};
